import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { httpOptions } from '@portal-workspace/grow-ui-library';
import { Observable } from 'rxjs';
import {
  ConsentDashboardAnalytics,
  ConsentDashboardGranularity,
  PayloadApiResponse,
} from '@portal-workspace/grow-shared-library';

const URL_ANALYTICS = (from: string, to: string, granularity: string) =>
  `${environment.api2Host}/api2/consent-dashboard/analytics?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&granularity=${encodeURIComponent(granularity)}`;

const URL_DOWNLOAD_CSV = (from: string, to: string, granularity: string) =>
  `${environment.api2Host}/api2/consent-dashboard/download-csv?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&granularity=${encodeURIComponent(granularity)}`;

@Injectable()
export class ConsentDashboardService {

  constructor(private httpClient: HttpClient) {
  }

  getAnalytics(from: string, to: string, granularity: ConsentDashboardGranularity): Observable<PayloadApiResponse<ConsentDashboardAnalytics>> {
    return this.httpClient.get<PayloadApiResponse<ConsentDashboardAnalytics>>(URL_ANALYTICS(from, to, granularity), httpOptions());
  }

  downloadCsv(from: string, to: string, granularity: ConsentDashboardGranularity): Observable<Blob> {
    const options = { ...httpOptions(), observe: 'body' as const, responseType: 'blob' as 'json' };
    return this.httpClient.get<Blob>(URL_DOWNLOAD_CSV(from, to, granularity), options);
  }
}
